import { TooltipIcon } from '@/components/tooltip-icon';
import { Flex, HStack, Text } from '@chakra-ui/react';

export const CostPill = () => {
  return (
    <HStack rounded="full" px={3} py={2} bg="#E9F0F3" gap={2.5} alignItems="center" color="#207B9B">
      <Flex position="relative">
        <TooltipIcon content={'Each spin costs 2 PLUME, which helps fund the rewards you can win.'} color="#207B9B" />
      </Flex>
      <Text fontWeight="500" fontSize="md" fontFamily="body" lineHeight="20px">
        1 Spin = 2 PLUME
      </Text>
    </HStack>
  );
};
